import {
  FETCH_MAILER_REQUEST,
  FETCH_MAILER_SUCCESS,
  FETCH_MAILER_ERROR,
  FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST,
  FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
  FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR,
  FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST,
  FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
  FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR,
  FETCH_ALL_MEASURES_REQUEST,
  FETCH_ALL_MEASURES_SUCCESS,
  FETCH_ALL_MEASURES_ERROR,
  FETCH_ALL_METRICS_REQUEST,
  FETCH_ALL_METRICS_SUCCESS,
  FETCH_ALL_METRICS_ERROR,
  CREATE_SCHEDULED_REPORT_REQUEST,
  CREATE_SCHEDULED_REPORT_SUCCESS,
  CREATE_SCHEDULED_REPORT_ERROR,
  UPDATE_SCHEDULED_REPORT_REQUEST,
  UPDATE_SCHEDULED_REPORT_SUCCESS,
  UPDATE_SCHEDULED_REPORT_ERROR,
  DELETE_SCHEDULED_REPORT_REQUEST,
  DELETE_SCHEDULED_REPORT_SUCCESS,
  DELETE_SCHEDULED_REPORT_ERROR,
  TOGGLE_REPORT_STATUS_REQUEST,
  TOGGLE_REPORT_STATUS_SUCCESS,
  TOGGLE_REPORT_STATUS_ERROR,
  RESET_MAILER_DATA,
  RESET_MAILER_ERROR,
  SET_SELECTED_MAILER_DATA,
  SET_MAILER_FORM_DATA
} from './mailerTypes';

const initialState = {
  // Loading states
  loading: false,
  userEmailerDetailsLoading: false,
  allEmailerDetailsLoading: false,
  measuresLoading: false,
  metricsLoading: false,

  // CRUD operation loading states
  createReportLoading: false,
  updateReportLoading: false,
  deleteReportLoading: false,
  toggleStatusLoading: false,

  // Data
  userEmailerDetails: [],
  allUserEmailerDetails: [],
  allMeasures: [],
  allMetrics: [],

  // Selected/Form data
  selectedMailerData: null,
  formData: {
    shareEmails: [],
    advertiser: null,
    selectedCampaigns: [],
    selectedDimensions: [],
    selectedMeasures: [],
    reportName: '',
    mailBody: 'Hi,\n\nPlease find the attached scheduled report for your review.\n\nBest regards,\nInmobi DSP Team',
    recurrence: 'Monthly',
    selectedDays: [],
    startDateTime: ''
  },

  // Error states
  error: null,
  userEmailerDetailsError: null,
  allEmailerDetailsError: null,
  measuresError: null,
  metricsError: null,
  createReportError: null,
  updateReportError: null,
  deleteReportError: null,
  toggleStatusError: null,

  // Success states
  createReportSuccess: false,
  updateReportSuccess: false,
  deleteReportSuccess: false,
  toggleStatusSuccess: false,

  // Messages
  successMessage: '',
  errorMessage: ''
};

const mailerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Generic loading and error states
    case FETCH_MAILER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MAILER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case FETCH_MAILER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        errorMessage: action.payload
      };

    // User reporting emailer details
    case FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST:
      return {
        ...state,
        userEmailerDetailsLoading: true,
        userEmailerDetailsError: null
      };

    case FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS:
      return {
        ...state,
        userEmailerDetailsLoading: false,
        userEmailerDetails: action.payload,
        userEmailerDetailsError: null
      };

    case FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR:
      return {
        ...state,
        userEmailerDetailsLoading: false,
        userEmailerDetails: [],
        userEmailerDetailsError: action.payload,
        errorMessage: action.payload
      };

    // All user reporting emailer details
    case FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST:
      return {
        ...state,
        allEmailerDetailsLoading: true,
        allEmailerDetailsError: null
      };

    case FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS:
      return {
        ...state,
        allEmailerDetailsLoading: false,
        allUserEmailerDetails: action.payload,
        allEmailerDetailsError: null
      };

    case FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR:
      return {
        ...state,
        allEmailerDetailsLoading: false,
        allUserEmailerDetails: [],
        allEmailerDetailsError: action.payload,
        errorMessage: action.payload
      };

    // All measures
    case FETCH_ALL_MEASURES_REQUEST:
      return {
        ...state,
        measuresLoading: true,
        measuresError: null
      };

    case FETCH_ALL_MEASURES_SUCCESS:
      return {
        ...state,
        measuresLoading: false,
        allMeasures: action.payload,
        measuresError: null
      };

    case FETCH_ALL_MEASURES_ERROR:
      return {
        ...state,
        measuresLoading: false,
        allMeasures: [],
        measuresError: action.payload,
        errorMessage: action.payload
      };

    // All metrics
    case FETCH_ALL_METRICS_REQUEST:
      return {
        ...state,
        metricsLoading: true,
        metricsError: null
      };

    case FETCH_ALL_METRICS_SUCCESS:
      return {
        ...state,
        metricsLoading: false,
        allMetrics: action.payload,
        metricsError: null
      };

    case FETCH_ALL_METRICS_ERROR:
      return {
        ...state,
        metricsLoading: false,
        allMetrics: [],
        metricsError: action.payload,
        errorMessage: action.payload
      };

    // Create scheduled report
    case CREATE_SCHEDULED_REPORT_REQUEST:
      return {
        ...state,
        createReportLoading: true,
        createReportError: null,
        createReportSuccess: false
      };

    case CREATE_SCHEDULED_REPORT_SUCCESS:
      return {
        ...state,
        createReportLoading: false,
        createReportError: null,
        createReportSuccess: true,
        successMessage: 'Report scheduled successfully!'
      };

    case CREATE_SCHEDULED_REPORT_ERROR:
      return {
        ...state,
        createReportLoading: false,
        createReportError: action.payload,
        createReportSuccess: false,
        errorMessage: action.payload
      };

    // Update scheduled report
    case UPDATE_SCHEDULED_REPORT_REQUEST:
      return {
        ...state,
        updateReportLoading: true,
        updateReportError: null,
        updateReportSuccess: false
      };

    case UPDATE_SCHEDULED_REPORT_SUCCESS:
      return {
        ...state,
        updateReportLoading: false,
        updateReportError: null,
        updateReportSuccess: true,
        successMessage: 'Report updated successfully!'
      };

    case UPDATE_SCHEDULED_REPORT_ERROR:
      return {
        ...state,
        updateReportLoading: false,
        updateReportError: action.payload,
        updateReportSuccess: false,
        errorMessage: action.payload
      };

    // Delete scheduled report
    case DELETE_SCHEDULED_REPORT_REQUEST:
      return {
        ...state,
        deleteReportLoading: true,
        deleteReportError: null,
        deleteReportSuccess: false
      };

    case DELETE_SCHEDULED_REPORT_SUCCESS:
      return {
        ...state,
        deleteReportLoading: false,
        deleteReportError: null,
        deleteReportSuccess: true,
        successMessage: 'Report deleted successfully!'
      };

    case DELETE_SCHEDULED_REPORT_ERROR:
      return {
        ...state,
        deleteReportLoading: false,
        deleteReportError: action.payload,
        deleteReportSuccess: false,
        errorMessage: action.payload
      };

    // Toggle report status
    case TOGGLE_REPORT_STATUS_REQUEST:
      return {
        ...state,
        toggleStatusLoading: true,
        toggleStatusError: null,
        toggleStatusSuccess: false
      };

    case TOGGLE_REPORT_STATUS_SUCCESS:
      return {
        ...state,
        toggleStatusLoading: false,
        toggleStatusError: null,
        toggleStatusSuccess: true,
        successMessage: 'Report status updated successfully!'
      };

    case TOGGLE_REPORT_STATUS_ERROR:
      return {
        ...state,
        toggleStatusLoading: false,
        toggleStatusError: action.payload,
        toggleStatusSuccess: false,
        errorMessage: action.payload
      };

    // Reset actions
    case RESET_MAILER_DATA:
      return {
        ...initialState
      };

    case RESET_MAILER_ERROR:
      return {
        ...state,
        error: null,
        userEmailerDetailsError: null,
        allEmailerDetailsError: null,
        measuresError: null,
        metricsError: null,
        createReportError: null,
        updateReportError: null,
        deleteReportError: null,
        toggleStatusError: null,
        errorMessage: '',
        successMessage: '',
        createReportSuccess: false,
        updateReportSuccess: false,
        deleteReportSuccess: false,
        toggleStatusSuccess: false
      };

    // Set selected data
    case SET_SELECTED_MAILER_DATA:
      return {
        ...state,
        selectedMailerData: action.payload
      };

    case SET_MAILER_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload
        }
      };

    default:
      return state;
  }
};

export default mailerReducer;
